import { timer, throwError, Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export interface RetryParams {
    maxAttempts?: number;
    scalingDuration?: number;
    shouldRetry?: ({ status, url }: { status: number; url: string }) => boolean;
}

// status codes that should be excluded from retry
const exclude = [400, 401, 403, 409, 500];

const excludeRequests = ['/view/datapoints/category/v1?categoryName', '/user-config/'];

const defaultParams: RetryParams = {
    maxAttempts: 3,
    scalingDuration: 1000,
    shouldRetry: ({ status, url }) => {
        const excludeUrl = excludeRequests.some((request) => url?.includes(request));
        return excludeUrl === false && status >= 400 && exclude.indexOf(status) === -1;
    }
};

export const genericRetryStrategy =
    (params: RetryParams = {}) =>
    (attempts: Observable<any>) =>
        attempts.pipe(
            mergeMap((error, i) => {
                const { maxAttempts, scalingDuration, shouldRetry } = {
                    ...defaultParams,
                    ...params
                };
                const retryAttempt = i + 1;
                // if maximum number of retries have been met
                // or response is a status code we don't wish to retry, throw error
                if (retryAttempt > maxAttempts || !shouldRetry(error.error || error)) {
                    return throwError(error);
                }
                console.log(
                    `Attempt ${retryAttempt}: retrying in ${
                        retryAttempt * scalingDuration
                    }ms`
                );
                // retry after 1s, 2s, etc...
                return timer(retryAttempt * scalingDuration);
            })
        );
